import React from 'react'
import { NewsletterPageState, FormUpdater, getValidationMessage, possibleSalutations, updaters } from './newsletter.state'
import { State, renderReadSpeaker } from '../../cmsPage.widget'
import { getClassNameModern } from '../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { expandableBlockClasses } from '../../modernBlocks/blocks/expandableBlock/expandableBlock.layout'
import { ReadSpeaker } from '../../../readspeaker/readspeaker.widget'
import { FormControls } from '../../../../../Shared/Frontend/forms'
import { t } from 'i18next'
import Recaptcha from 'react-grecaptcha'
import { capitalize } from '../../../../../Shared/Frontend/utils/capitalize'
import { Updater } from 'widgets-for-react'
import { SharingLayout } from '../../header/pageHeader/sharing.layout'
import { Link } from 'react-router-dom'
import { link, linkWrapper } from '../../utils/link'
import { SharedBlockLayout } from '../../modernBlocks/blocks/shared/sharedBlock.layout'

export const NewsletterPageLayout = {
  Content: (props: { children: any }) => {
    return (
      <div className="block__content ls-spacing">
        {props.children}
      </div>
    )
  },
  Form: (props: {
    state: NewsletterPageState
    validateField: FormUpdater
    updateInput: (field: keyof NewsletterPageState["form"], value: NewsletterPageState["form"][keyof NewsletterPageState["form"]], validate?: boolean) => void
    isDisabled: (field: keyof NewsletterPageState["form"]) => boolean
    // getValidation: (field: keyof NewsletterPageState["form"]) => SingleValidatorResult
    submitForm: (r: string) => void
  }) => {
    const { state } = props

    if (state.submitResult.kind === "loaded") {
      return <div className='donation__subheader'>
        <h2 className='donation__subtitle title--m'>{t("Newsletter:Success.Title")}</h2>
        <div className='text--styled'>
          <p>{t("Newsletter:Success.Intro")}</p>
          <p dangerouslySetInnerHTML={{ __html: t("Newsletter:Success.Avg") }} />
        </div>

        <div className='donation__action'>
          <SharedBlockLayout.Clickable
            id='newsletter-link-success'
            type='button'
            link={
              linkWrapper({
                title: t("Newsletter:Success.Link_Text"),
                url: t("Newsletter:Success.Link_Link")
              })
            }
            classNames={'button button--primary'}
          />
        </div>
      </div>
    }

    return (
      <>
        <div className='donation__subheader'>
          <h2 className='donation__subtitle title--m'>
            {t("Newsletter:Header.Title")}
          </h2>
          <div className='text--styled'>
            <p>
              {t("Newsletter:Header.Subtitle")}
            </p>
          </div>
        </div>

        <FormControls.FormRadioInGroup
          key={`newsletter-gender-b-newsletter`}
          name={`newsletter-gender-b-newsletter`}
          legend={t("Newsletter:Form.gender")}
          disabled={props.isDisabled("gender")}
          required={true}
          errorMessage={getValidationMessage(state, "gender")}
          items={possibleSalutations.map((item, index) => ({
            controlId: `donation-gender--b-newsletter-${index}`,
            label: capitalize(item.replace(/_/g, ' ')),
            checked: item === state.form.gender ? true : false,
            onChange: (checked: any) => checked ? props.updateInput("gender", item, true) : () => { }
          }))}
        />

        <div className='donation__row row--30-30-40'>
          <FormControls.FormItemInGroup
            key={`newsletter-initials-b-newsletter`}
            controlId={`donation-initials-b-newsletter`}
            type='text'
            inputMode='text'
            label={t("Newsletter:Form.initials")}
            disabled={props.isDisabled("initials")}
            required={true}
            value={state.form.initials}
            placeholder=''
            onChange={i => props.updateInput("initials", i)}
            onBlur={_ => props.validateField('initials')}
            errorMessage={getValidationMessage(state, "initials")}
          />

          <FormControls.FormItemInGroup
            key={`newsletter-infix-b-newsletter`}
            controlId={`donation-infix-b-newsletter`}
            type='text'
            inputMode='text'
            label={<><span className="label--small">{t("Newsletter:Form.insertion_s")}</span><span className="label--large">{t("Newsletter:Form.insertion")}</span></>}
            disabled={props.isDisabled("insertion")}
            required={false}
            value={state.form.insertion}
            placeholder=''
            onChange={i => props.updateInput("insertion", i)}
            onBlur={_ => props.validateField('insertion')}
            errorMessage={getValidationMessage(state, "insertion")}
          />

          <FormControls.FormItemInGroup
            key={`newsletter-lastname-b-newsletter`}
            controlId={`donation-lastname-b-newsletter`}
            type='text'
            inputMode='text'
            label={t("Newsletter:Form.lastName")}
            disabled={props.isDisabled("lastName")}
            required={true}
            value={state.form.lastName}
            placeholder=''
            onChange={i => props.updateInput("lastName", i)}
            onBlur={_ => props.validateField('lastName')}
            errorMessage={getValidationMessage(state, "lastName")}
          />
        </div>

        <FormControls.FormItemInGroup
          key={`newsletter-email-b-newsletter`}
          controlId={`donation-email-b-newsletter`}
          type='email'
          inputMode='email'
          label={t("Newsletter:Form.email")}
          disabled={props.isDisabled("email")}
          required={true}
          value={state.form.email}
          placeholder=''
          onChange={i => props.updateInput("email", i)}
          onBlur={_ => props.validateField('email')}
          errorMessage={getValidationMessage(state, "email")}
        />

        <FormControls.FormCheckInGroup
          key={`newsletter-newsletter-b-newsletter`}
          name={`newsletter-newsletter-b-newsletter`}
          legend={undefined}
          disabled={props.isDisabled("acceptTerms")}
          required={true}
          errorMessage={getValidationMessage(state, "acceptTerms")}
          items={[t("Newsletter:Form.acceptTerms")].map((item, index) => ({
            controlId: `donation-newsletter-b-newsletter-${index}`,
            label: capitalize(item),
            checked: Boolean(state.form.acceptTerms),
            onChange: i => props.updateInput("acceptTerms", i, true)
          }))}
        />
        <div id="recaptcha-content">
          <Recaptcha
            id="dtf-recaptcha"
            locale="NL_nl"
            sitekey={(document.getElementById('recaptchaToken') as any).value}
            callback={
              (r: string) => {
                props.submitForm(r)
              }
            }
            expiredCallback={() => window.grecaptcha.reset()}
            invisible
          />
        </div>

        <div className='donation__action'>
          <button
            className='button button--primary'
            onClick={() => {
              window.grecaptcha.reset()
              window.grecaptcha.execute()
            }}
            disabled={state.submitResult.kind == 'loading'}
          >
            <span className="button__label">{t("Newsletter:Form.Submit")}</span>
          </button>
        </div>

        {/* <div className='donation__avg text--styled text--s'>
          <p dangerouslySetInnerHTML={{ __html: t("Newsletter:Form.avg") }} />
        </div> */}
      </>
    )
  },
  Wrapper: (props: { children?: React.ReactNode }) => <>
    <section className="block block--donation inview">
      <div className="block__inner ls-container--l">
        <div className="block__layout">
          {props.children}
        </div>
      </div>
    </section>
  </>,
  Inner: (props: { children?: React.ReactNode, blocks: React.ReactNode, text: string, title: string, state: State }) => <>
    <div className='donation ls-container ls-gutter ls-spacing--s'>
      <div className='donation__inner'>
        <div className='donation__form'>
          {props.children}
        </div>
      </div>
    </div>

    <div className='block__wrap'>
      <SharingLayout.Wrap>
        {renderReadSpeaker(props.state) == true && <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />}
        <SharingLayout.Button />
        <SharingLayout.Popup />
      </SharingLayout.Wrap>

      {props.blocks}
    </div>
  </>
}
